import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DigitalCardVariablePaletteDialogData } from "../digital-cards.interface";

@Component({
  selector: "app-digital-card-variable-palette-dialog",
  templateUrl: "./digital-card-variable-palette-dialog.component.html",
  styleUrls: ["./digital-card-variable-palette-dialog.component.scss"],
  standalone: false,
})
export class DigitalCardVariablePaletteDialogComponent {
  targetEditor: { insertVariable: (text: string) => void };

  constructor(
    public dialogRef: MatDialogRef<DigitalCardVariablePaletteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DigitalCardVariablePaletteDialogData,
  ) {
    this.targetEditor = {
      insertVariable: (text: string) => {
        this.data.onInsertVariable(text);
      },
    };
  }

  close(): void {
    this.dialogRef.close();
  }
}
